import { StorageService } from './storage';
import { Conversation } from '../types/chat';

export class TabsService {
  constructor(private storage: StorageService) {}

  createTab(model?: string): Conversation {
    const settings = this.storage.getSettings();
    const modelToUse = model || settings.defaultModel;
    return this.storage.createConversation(modelToUse);
  }

  switchTab(conversationId: string): void {
    this.storage.setActiveConversation(conversationId);
  }

  closeTab(conversationId: string): void {
    const activeConv = this.storage.getActiveConversation();
    const allConvs = this.storage.getAllConversations();

    // If closing the active tab
    if (activeConv?.id === conversationId) {
      // Find next tab to switch to
      const currentIndex = allConvs.findIndex(c => c.id === conversationId);
      let nextConv: Conversation | null = null;

      if (allConvs.length > 1) {
        // Try next tab, or previous if this is the last
        if (currentIndex < allConvs.length - 1) {
          nextConv = allConvs[currentIndex + 1];
        } else if (currentIndex > 0) {
          nextConv = allConvs[currentIndex - 1];
        }
      }

      // Delete the conversation
      this.storage.deleteConversation(conversationId);

      // Switch to next tab or create new one
      if (nextConv) {
        this.storage.setActiveConversation(nextConv.id);
      } else {
        // No tabs left, create a new one
        this.createTab();
      }
    } else {
      // Not active tab, just delete
      this.storage.deleteConversation(conversationId);
    }
  }

  resetActiveTab(): void {
    const active = this.storage.getActiveConversation();
    if (active) {
      this.storage.resetConversation(active.id);
    }
  }

  getAllTabs(): Conversation[] {
    return this.storage.getAllConversations();
  }

  getActiveTab(): Conversation | null {
    return this.storage.getActiveConversation();
  }
}
